<template>
  <AsyncPage
    :loader="useCompanyProfileLoader"
    :page-component="CompanyProfile"
  />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from "vue";
import { useCompanyProfileLoader } from "./CompanyProfile.loader.ts";
import { AsyncPage } from "@saflib/vue/components";
const CompanyProfile = defineAsyncComponent(
  () => import("./CompanyProfile.vue"),
);
</script>
